import { __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import { FieldActions } from '../Fields';
import { ContactCustomFieldType } from '../../../types';
import FieldActionsMenu from '../FieldActionsMenu/FieldActionsMenu';
import { DateInput } from '../DateInput/DateInput';
import { FormField, NumberInput, Input, Box, Layout, Cell, } from 'wix-style-react';
export var dateFormat = function (date) {
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString();
};
export var customDataHook = function (field) {
    return "custom-field-" + field.id;
};
var CustomField = /** @class */ (function (_super) {
    __extends(CustomField, _super);
    function CustomField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    CustomField.prototype.handleOnValueChange = function (value) {
        this.props.onFieldValueChange(this.props.field, value);
    };
    CustomField.prototype.render = function () {
        var _a;
        var _this = this;
        var field = this.props.field;
        return (React.createElement(Layout, { gap: 10, dataHook: customDataHook(field) },
            React.createElement(Cell, { span: 2 },
                React.createElement(FormField, { label: field.name, dataHook: "field-label-text-" + field.id })),
            React.createElement(Cell, { span: 9 }, (_a = {},
                _a[ContactCustomFieldType.Text] = (React.createElement(Layout, { gap: 0 },
                    React.createElement(Cell, { span: 12 },
                        React.createElement(Input, { dataHook: "field-value-" + field.id + "-" + field.customFieldType, placeholder: field.name, value: field.value || '', onChange: function (e) { return _this.handleOnValueChange(e.target.value); } })))),
                _a[ContactCustomFieldType.URL] = (React.createElement(Layout, { gap: 0 },
                    React.createElement(Cell, { span: 12 },
                        React.createElement(Input, { dataHook: "field-value-" + field.id + "-" + field.customFieldType, placeholder: field.name, value: field.value || '', onChange: function (e) { return _this.handleOnValueChange(e.target.value); } })))),
                _a[ContactCustomFieldType.Number] = (React.createElement(Layout, { gap: 0 },
                    React.createElement(Cell, { span: 12 },
                        React.createElement(NumberInput, { dataHook: "field-value-" + field.id + "-" + field.customFieldType, placeholder: field.name, value: field.value, onChange: function (value) {
                                return _this.handleOnValueChange(value);
                            }, max: 999999999999999, min: -999999999999999 })))),
                _a[ContactCustomFieldType.Date] = (React.createElement(Layout, { gap: 0 },
                    React.createElement(Cell, { span: 12 },
                        React.createElement(DateInput, { dataHook: "field-value-" + field.id + "-" + field.customFieldType, value: field.value ? field.value : '', placeholder: field.name, onChange: function (date) { return _this.handleOnValueChange(date); }, lng: this.props.lng || 'en' })))),
                _a)[field.customFieldType]),
            React.createElement(Cell, { span: 1 },
                React.createElement(Box, { align: "right", marginLeft: "50px", marginTop: "3px" },
                    React.createElement(FieldActionsMenu, { actions: [FieldActions.RENAME], dataHook: field.name, onActionClicked: this.props.onActionClicked })))));
    };
    return CustomField;
}(React.PureComponent));
export default translate()(CustomField);
//# sourceMappingURL=CustomField.js.map